import { getApm } from 'shared/apm';
import PageApp from 'renderer/PageApp';
import { getRootData, hydrateClient } from 'client/shared/hydrateClient';
import { onError } from 'client/shared/apmOnError';

export const renderPageClient = () => {
  getApm('full-instrumentation');

  const rootData = getRootData();
  const { content, config } = rootData;
  const { componentData, pageData, preloadedData = {} } = content || {};

  if (!pageData) {
    const error = new Error('Content Renderer: pageData missing for PageApp');

    return onError(error, {
      logger: 'ContentRenderer | renderPageClient',
      section: 'Hydration Error',
    });
  }

  return hydrateClient({
    loggerName: 'renderPageClient',
    appElement: (
      <PageApp
        componentLibraryConfig={{
          ...(config || {}),
          cfDomain: config?.cfDomain ?? '',
        }}
        componentData={componentData || []}
        pageData={pageData}
        preloadedData={preloadedData}
      />
    ),
    rootData,
  });
};
